frappe.desktop_utils = {};
frappe.desktop_grids = [];
frappe.desktop_icons_objects = [];

// @dokos: the same rule as get_route() in desktop_icons.bundle.js. The launcher used to resolve
// icons through the sidebar payload keyed by lowercased workspace title, which boot no longer
// sends: it was replaced by the module-keyed `frappe.boot.module_sidebars`.
function get_route(desktop_icon) {
	let route;
	if (!desktop_icon) return;
	if (desktop_icon.link_type == "External" && desktop_icon.link) {
		route = window.location.origin + desktop_icon.link;
		if (desktop_icon.link.startsWith("http")) {
			route = desktop_icon.link;
		}
	} else if (desktop_icon.link_type == "Workspace Sidebar") {
		let sidebar = frappe.utils.sidebar_for_module(desktop_icon.module || desktop_icon.label);
		if (sidebar) route = frappe.app.sidebar?.module_landing_route(sidebar.name);
	}
	return route;
}

// @dokos: the app tiles of the Apps screen, as DesktopPage.render_app_icons() builds them in
// frappe/desk/page/desktop/desktop.js. That page script is only loaded on /desk, so it cannot be
// called from here: keep the two in step.
function get_apps_screen_icons() {
	return (frappe.boot.app_data || [])
		.filter((app) => app.on_apps_screen)
		.sort((a, b) => (a.sequence_id ?? 100) - (b.sequence_id ?? 100))
		.map((app) => ({
			label: app.app_title,
			logo_url: app.app_logo_url,
			desk_route: app.desk_route,
			route: frappe.app.sidebar?.app_landing_route(app) || app.app_route || "/desk",
		}));
}

export class DesktopLauncher {
	constructor(wrapper) {
		this.wrapper = $(wrapper);
		this.ensure_desktop_icons();
		this.prepare();
		this.make();
	}

	ensure_desktop_icons() {
		// Boot sends the Desktop Icon rows only in "Desktop Icons" mode (see is_desktop_icons_page)
		if (!frappe.boot.desktop_icons) {
			frappe.boot.desktop_icons = [];
		}
	}

	// @dokos: the launcher shows what /desk shows. Desktop Settings -> Desktop Page picks the
	// Desktop Icon grid or the app tiles of the Apps screen, the default.
	shows_desktop_icons() {
		return frappe.boot.desktop_page === "Desktop Icons";
	}

	update() {
		this.prepare();
		this.make();
	}

	prepare() {
		this.apps_icons = [];
		if (!this.shows_desktop_icons()) {
			this.apps_icons = get_apps_screen_icons();
			return;
		}

		const icon_map = {};
		frappe.desktop_icons = frappe.boot.desktop_icons;
		let icons = frappe.desktop_icons;
		const all_icons = icons.filter((icon) => {
			if (icon.hidden != 1) {
				icon.child_icons = [];
				icon_map[icon.label] = icon;
				return true;
			}
			return false;
		});
		all_icons.forEach((icon) => {
			if (icon.parent_icon && icon_map[icon.parent_icon]) {
				icon_map[icon.parent_icon].child_icons.push(icon);
			}

			if (!icon.parent_icon || !icon_map[icon.parent_icon]) {
				this.apps_icons.push(icon);
			}
		});
	}

	make() {
		this.wrapper.empty();
		$(`<div class="desktop-modal-wrapper">
			<div class="desktop-modal-desktop-wrapper">
				<div class="desktop-modal-desktop-container">
				</div>
			</div>
			<div class="desktop-shortcut-legend">
				<table>
					<tr>
						<td class="shortcut-key"><kbd>Ctrl+G</kbd></td>
						<td class="shortcut-desc">Toggle Desktop Icons</td>
					</tr>
				</table>
			</div>
		</div>`).appendTo(this.wrapper);

		this.container = this.wrapper.find(".desktop-modal-desktop-container");
		this.container.data("desktop_page", this);
		this.show_main_grid();
	}

	show_main_grid() {
		this.container.empty();
		this.icon_grid = new DesktopIconGrid({
			wrapper: this.container,
			icons_data: this.apps_icons,
			desktop_page: this,
			// the Apps screen orders apps by their hook's sequence_id
			keep_order: !this.shows_desktop_icons(),
		});
	}
}

class DesktopIconGrid {
	constructor(opts) {
		$.extend(this, opts);
		this.icons = [];
		this.icons_html = [];
		this.grids = [];

		if (!this.desktop_page) {
			this.desktop_page = this.wrapper.data("desktop_page");
		}

		this.prepare();
		this.make();
		frappe.desktop_grids.push(this);
	}

	prepare() {
		if (!this.keep_order) {
			this.icons_data = this.icons_data.sort((a, b) => {
				return __(a.label).localeCompare(__(b.label)); // @dokos: only sort by label not by idx
			});
		}

		const page_size = 24; // 6x4 grid
		this.total_pages = Math.ceil(this.icons_data.length / page_size) || 1;
		this.icons_data_by_page = [];
		for (let i = 0; i < this.total_pages; i++) {
			this.icons_data_by_page.push(
				this.icons_data.slice(i * page_size, (i + 1) * page_size)
			);
		}
	}

	make() {
		if (this.in_folder) {
			this.add_back_button();
		}

		this.icons_container = $(`<div class="desktop-modal-icons-container"></div>`).appendTo(
			this.wrapper
		);

		for (let i = 0; i < this.total_pages; i++) {
			let template = `<div class="desktop-modal-icons"></div>`;

			if (this.row_size) {
				template = `<div class="desktop-modal-icons" style="grid-template-columns: repeat(${this.row_size}, 1fr)"></div>`;
			}
			this.grids.push($(template).appendTo(this.icons_container));
			this.make_icons(this.icons_data_by_page[i], this.grids[i]);
		}

		if (this.total_pages > 1) {
			this.add_page_indicators();
			this.add_nav_arrows();
			this.setup_pagination();
			this.setup_swipe_gesture();
		} else {
			this.grids[0] && this.grids[0].css("display", "grid");
		}
	}

	setup_swipe_gesture() {
		const me = this;
		this.grids.forEach((grid) => {
			$(grid).on("wheel", function (event) {
				if (event.originalEvent) {
					event = event.originalEvent;
				}

				if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
					event.preventDefault();
					if (event.deltaX > 0) {
						if (me.current_page < me.total_pages - 1) {
							me.change_to_page(me.current_page + 1);
						}
					} else {
						if (me.current_page > 0) {
							me.change_to_page(me.current_page - 1);
						}
					}
				}
			});
		});
	}

	add_page_indicators() {
		this.page_indicators = [];
		this.pagination_indicator = $(`<div class='page-indicator-container'></div>`).appendTo(
			this.wrapper.parent()
		);
		for (let i = 0; i < this.total_pages; i++) {
			this.page_indicators.push(
				$("<div class='page-indicator'></div>").appendTo(this.pagination_indicator)
			);
		}
	}

	setup_pagination() {
		this.current_page = this.old_index = 0;
		this.change_to_page(this.current_page);
	}

	add_nav_arrows() {
		const me = this;

		this.btn_prev = $(
			`<div class="desktop-nav-arrow left-arrow">${frappe.utils.icon("left", "md")}</div>`
		).appendTo(this.wrapper.parent());
		this.btn_next = $(
			`<div class="desktop-nav-arrow right-arrow">${frappe.utils.icon("right", "md")}</div>`
		).appendTo(this.wrapper.parent());

		this.btn_prev.on("click", () => {
			if (me.current_page > 0) {
				me.change_to_page(me.current_page - 1);
			}
		});

		this.btn_next.on("click", () => {
			if (me.current_page < me.total_pages - 1) {
				me.change_to_page(me.current_page + 1);
			}
		});
	}

	change_to_page(index) {
		// Hide all grids
		this.grids.forEach((g) => $(g).css("display", "none"));

		// Show current grid
		this.grids[index].css("display", "grid");

		// Update page indicators
		if (this.page_indicators.length) {
			this.page_indicators[this.old_index].removeClass("active-page");
			this.page_indicators[index].addClass("active-page");
		}

		// Update arrow states
		if (this.btn_prev && this.btn_next) {
			this.btn_prev.toggleClass("disabled", index === 0);
			this.btn_next.toggleClass("disabled", index === this.total_pages - 1);
		}

		this.current_page = index;
		this.old_index = index;
	}

	make_icons(icons_data, grid) {
		icons_data.forEach((icon) => {
			let icon_obj = new DesktopIcon(icon);
			let icon_html = icon_obj.get_desktop_icon_html();
			if (icon_html) {
				this.icons.push(icon_obj);
				this.icons_html.push(icon_html);
				grid.append(icon_html);
			}
		});
	}

	add_back_button() {
		this.back_button = $(`<div class="desktop-back-button">
			${frappe.utils.icon("left", "md")}
		</div>`).prependTo(this.wrapper);

		this.back_button.on("click", () => {
			if (this.desktop_page) {
				this.desktop_page.show_main_grid();
			}
		});
	}
}

class DesktopIcon {
	constructor(icon) {
		this.icon_data = icon;
		this.icon_title = this.icon_data.label;
		this.icon_subtitle = "";
		this.icon_type = this.icon_data.icon_type;
		this.icon_data.in_folder = true;
		this.link_type = this.icon_data.link_type;
		if (this.icon_type != "Folder") {
			this.icon_route = this.icon_data.route || get_route(this.icon_data);
		}
		if (this.icon_data.child_icons) {
			this.child_icons = this.get_child_icons_data();
		}
		let render = this.validate_icon();
		if (render) {
			this.icon = $(
				frappe.render_template("desktop_icon", {
					icon: this.icon_data,
					in_folder: false,
				})
			);
			this.icon_caption_area = $(this.icon.get(0).children[1]);
			this.setup_click();
			this.render_folder_thumbnail();
			frappe.desktop_icons_objects.push(this);
		}
	}

	validate_icon() {
		if (this.icon_type == "Folder") {
			if (this.icon_data.child_icons.length == 0) return false;
		}
		return true;
	}

	get_child_icons_data() {
		return this.icon_data.child_icons.sort((a, b) => a.idx - b.idx);
	}

	get_desktop_icon_html() {
		return this.icon;
	}

	setup_click() {
		const me = this;
		if (this.child_icons?.length && (this.icon_type == "App" || this.icon_type == "Folder")) {
			// Prevent default link behavior for folders
			$(this.icon).on("click", function (e) {
				e.preventDefault();

				// Get desktop_page from the wrapper
				const desktop_page = $(e.currentTarget)
					.closest(".desktop-modal-desktop-container")
					.data("desktop_page");

				if (desktop_page) {
					// Clear the entire container to replace with folder contents
					desktop_page.container.empty();
					// Create new grid with child icons
					new DesktopIconGrid({
						wrapper: desktop_page.container,
						icons_data: me.child_icons,
						in_folder: true,
						parent_icon: me,
						desktop_page: desktop_page,
					});
				}
			});
			// Remove href to prevent navigation
			this.icon.removeAttr("href");
			this.icon.css("cursor", "pointer");
		} else if (this.icon_route) {
			// @dokos: the tile is a <div> whose logo and title are the links, as on /desk
			// (DesktopPage.add_icon). An href on the tile itself leads nowhere.
			const $links = this.icon.find(".icon-link, .icon-title");
			$links.attr("href", this.icon_route);
			if (this.icon_route.startsWith("http")) {
				$links.attr("target", "_blank");
			}
			// the router handles the click; the launcher must not stay open over the new page
			this.icon.find("a").on("click", () => frappe.desktop_launcher?.hide());
		}
	}

	render_folder_thumbnail() {
		let condition =
			frappe.boot.show_app_icons_as_folder &&
			this.icon_type == "App" &&
			this.child_icons.length > 0;
		if (this.icon_type == "Folder" || condition) {
			if (!this.folder_wrapper) this.folder_wrapper = this.icon.find(".icon-container");
			this.folder_wrapper.html("");
			new DesktopIconGrid({
				wrapper: this.folder_wrapper,
				icons_data: this.child_icons,
				row_size: 4,
				in_folder: true,
				no_dragging: true,
			});
			if (this.icon_type == "App") {
				this.folder_wrapper.addClass("folder-icon");
			}
		}
	}
}
